import { WifiSlash } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

interface OfflineBannerProps {
  visible: boolean;
  message: string;
}

export function OfflineBanner({ visible, message }: OfflineBannerProps) {
  if (!visible) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "flex items-center gap-2 px-3 py-2 bg-biz-warning-subtle text-biz-warning border-b border-biz-warning-border",
      )}
    >
      <WifiSlash size={16} weight="regular" />
      <span className="text-xs font-medium">{message}</span>
    </div>
  );
}
